export default __webpack_public_path__ + "static/media/video-banner.64403e0a.png";